// src/configs/firebaseConfig.js

// 開発
// Firebase Console -> Project settings -> General -> Your apps -> Firebase SDK snippet (Config) から取得した情報
// const firebaseConfig = {
//     apiKey: "AIzaSyDScTul1THqzC6u9YFUlIkaGhiZqtB7FGM", // お客様の実際のAPIキー
//     authDomain: "my-accounting-app-8f8e5.firebaseapp.com", // お客様の実際の認証ドメイン
//     projectId: "my-accounting-app-8f8e5", // お客様の実際のプロジェクトID
//     storageBucket: "my-accounting-app-8f8e5.firebasestorage.app", // お客様の実際のストレージバケット
//     messagingSenderId: "826649108391", // お客様の実際のメッセージングセンダーID
//     appId: "1:826649108391:web:3dd44d83b6867bc4776082", // お客様の実際のApp ID
//     measurementId: "G-XG8ERQ7DW9" // お客様の実際のMeasurement ID（ある場合）
// };

// src/configs/firebaseConfig.js

// 本番
// Firebase Console -> Project settings -> General -> Your apps -> Firebase SDK snippet (Config) から取得した情報
const firebaseConfig = {
    apiKey: "AIzaSyBfouBzL7vmpb01WSn6Vr4stWTw6K8Lkk0",
    authDomain: "moneyboard-97690.firebaseapp.com",
    projectId: "moneyboard-97690",
    storageBucket: "moneyboard-97690.firebasestorage.app",
    messagingSenderId: "383027274646",
    appId: "1:383027274646:web:3039464c5870e1b608b3b7",
    measurementId: "G-7HHZ57G1E1"
};


// Firestoreのパスで使用するためのApp ID (通常はprojectIdと同じ)
const firebaseAppId = firebaseConfig.projectId;

export { firebaseConfig, firebaseAppId };
